import { useInfiniteQuery } from 'react-query';
import { getSceneContents, type SceneContentsResponse } from '../../services/sceneService';

export function useGetSceneContents(sceneId: string, options?: { enabled?: boolean }) {
  const { enabled = true } = options ?? {};

  return useInfiniteQuery(
    ['sceneContents', sceneId],
    ({ pageParam }: { pageParam?: number }) => getSceneContents({ sceneId, cursor: pageParam }),
    {
      enabled: !!sceneId && enabled,
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      getNextPageParam: (lastPage) => {
        const { pagination } = lastPage ?? {};
        if (pagination?.has_more && pagination?.next_cursor != null) {
          return pagination.next_cursor;
        }
        return undefined;
      }
    }
  );
}

export function flattenSceneContents(
  data: ReturnType<typeof useGetSceneContents>['data']
): SceneContentsResponse {
  if (!data?.pages) return [];
  return data.pages.flatMap((page) => page.contents ?? []);
}
